import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { injectIntl } from 'react-intl';
import './Carousel.scss';

class Carousel extends Component {
  static propTypes = {
    /** this is required for the app to know what class to use in the layout */
    isSplash: PropTypes.bool,
    /** carousel setting to display dot navigation */
    withDots: PropTypes.bool,
    /** This is to center items where you can see the next or previous one */
    isCenterMode: PropTypes.bool,
    /** use this to pass the splash list object */
    splashList: PropTypes.arrayOf(PropTypes.object),
    /** use this to pass the option list object */
    optionList: PropTypes.arrayOf(PropTypes.object),
    /** Children is used to customize the slider items */
    children: PropTypes.node,
    centerPadding: PropTypes.string,
    variableWidth: PropTypes.bool,
    autoplay: PropTypes.bool,
    rtl: PropTypes.bool,
    /** initial slide */
    initialSlide: PropTypes.number,
  };

  static defaultProps = {
    isSplash: false,
    withDots: false,
    isCenterMode: false,
    splashList: [],
    optionList: [],
    children: null,
    centerPadding: '10px',
    variableWidth: false,
    autoplay: false,
    rtl: false,
    initialSlide: null,
  };

  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
  }

  next() {
    this.slider.slickNext();
  }

  onTestInputChange = (e) => {
    console.log(e.target.value);
    this.slider.slickGoTo(e.target.value);
  };

  render() {
    const {
      withDots, isCenterMode, children, initialSlide, centerPadding, variableWidth, className, fowardRef, beforeChange, autoplay, rtl,
    } = this.props;

    /** Slider Settings  */
    const settings = {
      autoplay,
      dots: withDots,
      centerMode: isCenterMode,
      centerPadding,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: initialSlide || 0,
      variableWidth,
      beforeChange,
      rtl,
    };

    return (
        <>
          <input value={0} onChange={this.onTestInputChange} className="test-dummy" />
          {/* eslint-disable-next-line no-return-assign */}
          <Slider {...settings} ref={fowardRef || (c => (this.slider = c))} className={`carousel carousel--dynamic ${className || ''}`}>
            {children}
          </Slider>
          </>
    );
  }
}

export default injectIntl(Carousel);
